import { createSelector } from 'reselect';
import { RootState } from '../reducers';
import { TabAccessState } from '../reducers/tabs-access';

const getTabsAccess = (state: RootState): TabAccessState => state.tabsAccess;

export const getTabsAccessData = createSelector(getTabsAccess, (tabsAccess) => tabsAccess.data);

export default getTabsAccessData;
